import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ChatInterface from './features/chat/components/ChatInterface';
import ChannelManagementClient from './features/channel/components/ChannelManagementClient';
import UserSelector from './features/auth/UserSelector';
import { useAuth } from './context/AuthContext';
import './index.css';
import './components/toastStyles.css';

const AppContent = () => {
  const { user, setUser } = useAuth();

  const handleUserSelected = (selectedUser) => {
    setUser(selectedUser);
  };

  return (
    <>
      {/* Show premium user picker overlay when no session exists */}
      {!user && <UserSelector onUserSelected={handleUserSelected} />}

      <div className="min-h-screen bg-[var(--bg-darker)] text-[var(--text-main)] transition-colors duration-500">
        <Routes>
          <Route path="/chat-interface" element={<ChatInterface />} />
          <Route path="/channel/:id" element={<ChatInterface />} />
          <Route path="/dm/:id" element={<ChatInterface />} />
          <Route path="/channel-management" element={<ChannelManagementClient />} />
          <Route path="/" element={<Navigate to="/chat-interface" replace />} />
          <Route path="*" element={<Navigate to="/chat-interface" replace />} />
        </Routes>
      </div>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: 'var(--bg-surface)',
            color: 'var(--text-main)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '12px',
            fontFamily: 'inherit',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: 'white',
            },
            duration: 3000,
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: 'white',
            },
            duration: 3000,
          },
        }}
      />
    </Router>
  );
};

export default App;